/**
 * Предоставляет функции для работы с координатами
 */
var MapHelper = (function () {

  var MapHelper = function () {
    //TODO: удалить этот return. Оставил его для совместимости, так как пока используется var mapHelper = MapHelper()
    return {
      findPosition: MapHelper.findPosition,
      getLongObjectCoordinatesCsv: MapHelper.getLongObjectCoordinatesCsv,
      findPositionByDistance: MapHelper.findPositionByDistance,
      getZoom: MapHelper.getZoom
    };
  };

  var zoomCoefficient = {
      6: 8000,
      7: 4000,
      8: 2000,
      9: 1000,
      10: 500,
      11: 250,
      12: 125,
      13: 75,
      14: 50,
      15: 30,
      16: 20,
      17: 10,
      18: 10
  }

  MapHelper.getZoom = function (map) {
    var coefficient = 125;
    if (map) {
      var zoom = map.getZoom();
      coefficient = zoomCoefficient[zoom] ? zoomCoefficient[zoom] : coefficient;
    }
    return { zoom: zoom, coefficient: coefficient };
  }

  /**
   * Определение нахождения точки на заданном отрезке с учетом коэффициента смещения
   * 
   * @private
   * @param {} lineStart 
   * @param {} lineEnd 
   * @param {} point 
   * @returns {} 
   */
  function pointInEdge(lineStart, lineEnd, point, coefficient) {
    
    var distToStart = point.distanceTo(lineStart);
    var distToEnd = point.distanceTo(lineEnd);
    var distTotal = lineStart.distanceTo(lineEnd);

    var isInEdge = distToStart + distToEnd < distTotal + coefficient;

      if (isInEdge) {
          var inEdge = L.LineUtil.pointToSegmentDistance(L.point(point.lat, point.lng),
              L.point(lineStart.lat, lineStart.lng), L.point(lineEnd.lat, lineEnd.lng));
        return { isInEdge: true, distance: distToStart, total: distTotal, inEdge: inEdge };
    }

      return { isInEdge: false, distance: distTotal };
  };

  /**
   * Конвертирует координаты в LatLng
   * 
   * @public
   * @param {GeoPoint[]|GeoPoint} coordinates Массив координат
   * @returns {LatLng[]|LatLng} Массив координат для Leaflet
   */
  MapHelper.convertToLatLng = function (coordinates) {
      if (Array.isArray(coordinates)) {
          if (coordinates.length && Array.isArray(coordinates[0])) {
              return coordinates.map(function(a) {
                  return a.map(function(c) {
                      return new L.LatLng(c.Lat, c.Lng);
                  });
              });
          } else {
              return coordinates
                  .map(function(c) {
                      return new L.LatLng(c.Lat, c.Lng);
                  });
          }
      }
    return new L.LatLng(coordinates.Lat, coordinates.Lng);
    };

  MapHelper.parseStringToLatLng = function (coordinatesSvg) {
    if (coordinatesSvg.length === 0)
      return [];
    try {
      return coordinatesSvg.split('\n').map(function (c) {
        const latlng = c.split(',');
        const lat = parseFloat(latlng[0]);
        const lng = parseFloat(latlng[1]);
        if (isNaN(lat) || isNaN(lng)) throw '';
        return new L.LatLng(lat, lng);
      });
    } catch (ex) {
      return undefined;
    }
  };

    MapHelper.parseStringToSplitLatLng = function (coordinatesSvg) {
        if (coordinatesSvg.length === 0)
            return [[]];
        try {
            var sections = [];
            var segmStr = coordinatesSvg.split('\n---\n');
            for (var i = 0; i < segmStr.length; i++) {
                sections[i] = segmStr[i].split('\n').map(function (c) {
                    const latlng = c.split(',');
                    const lat = parseFloat(latlng[0]);
                    const lng = parseFloat(latlng[1]);
                    if (isNaN(lat) || isNaN(lng)) throw '';
                    return new L.LatLng(lat, lng);
                }); 
            }
            return sections;
        } catch (ex) {
            return undefined;
        }
    };

  /**
   * Находит расположение точки на линии
   * 
   * @public
   * @param {Object<>} point Координаты точки
   * @param {Object<>} linePoints Координаты дороги
   * @param {number} Коэффициент масштаба карты
   * @returns {Object<>} Расположение точки на линии
   */
  MapHelper.findPosition = function (point, linePoints, coefficient) {
    var result = {
      index: null,
      section: 0,
      distance: 0,
      isInEdge: false,
      inEdge: 0
    };
      var results = [];

      if (linePoints.length && Array.isArray(linePoints[0])) {
          for (let i = 0; i < linePoints.length; i++) {
              for (var j = 1; j < linePoints[i].length; j++) {
                  let checkResult = pointInEdge(linePoints[i][j - 1], linePoints[i][j], point, coefficient);
                  result.distance += checkResult.distance;
                  result.isInEdge = checkResult.isInEdge;
                  if (checkResult.isInEdge) {
                      result.index = j;
                      result.section = i;
                      result.inEdge = checkResult.inEdge;

                      results.push({
                          index: j,
                          section: i,
                          distance: result.distance,
                          isInEdge: true,
                          inEdge: checkResult.inEdge
                      });
                      result.distance += checkResult.total - checkResult.distance;
                  }
              }
          }
      } else {

          for (let i = 1; i < linePoints.length; i++) {
              let checkResult = pointInEdge(linePoints[i - 1], linePoints[i], point, coefficient);
              result.distance += checkResult.distance;
              result.isInEdge = checkResult.isInEdge;
              if (checkResult.isInEdge) {
                  result.index = i;
                  result.inEdge = checkResult.inEdge;

                  results.push({
                      index: i,
                      distance: result.distance,
                      isInEdge: true,
                      inEdge: checkResult.inEdge
                  });
                  result.distance += checkResult.total - checkResult.distance;
              }
          }
      }

      var lowest = {inEdge: Number.MAX_VALUE};
    var outPosition;
    results.forEach(function (position, idx) {
      outPosition = position;
      if (outPosition.inEdge < lowest.inEdge) lowest = outPosition;
    });

    return lowest;
  };

  /**
   * Вернет координаты участка дороги от distanceToStart до distanceToEnd
   * 
   * @public
   * @param {} coordinates Координаты дороги
   * @param {} distanceToStart Растояние от начала дороги
   * @param {} distanceToEnd Растояние от начала дороги
   * @returns {} 
   */
  MapHelper.getCoordinatesByStartEnd = function (coordinates, distanceToStart, distanceToEnd) {

    var start = MapHelper.findPositionByDistance(distanceToStart, coordinates);
    var end = MapHelper.findPositionByDistance(distanceToEnd, coordinates);

    var points = [];
      if (start.section !== end.section) {
          points.push([]);
          points[points.length - 1].push(start.point);
          for (let i = start.index; i < coordinates[start.section].length; i++) {
              points[points.length - 1].push(coordinates[start.section][i]);
          }
          for (let j = start.section + 1; j < end.section; j++) {
              points.push([]);
              for (let i = 0; i < coordinates[j].length; i++) {
                  points[points.length - 1].push(coordinates[j][i]);
              }
          }
          points.push([]);
          for (let i = 0; i < end.index; i++) {
              points[points.length - 1].push(coordinates[end.section][i]);
          }
          points[points.length - 1].push(end.point);
      } else {
          points.push(start.point);
          for (var i = start.index; i < end.index; i++) {
              points.push(coordinates[start.section][i]);
          }
          points.push(end.point);
      }

      return points;
  };

  /**
   * Вернет точку на ломанной линии, отстоящую от начала на расстоянии distance,
   * или конечную точку, если distance больше длины ломаного отрезка
   *
   * @public
   * @param {Double} distance Расстояние в метрах от начальной точки
   * @param {LatLng[]} points Координаты
   * @returns {Object} Объект специального типа
   */
  MapHelper.findPositionByDistance = function(distance, points) {
        var result = {
            index: null,
            section: null,
            point: null,
            edgeDistance: 0
        };
      if (!Array.isArray(points[0])) {
          points = [points];
      }
      var currentDistance = 0;
      var found = false;
      for (var j = 0; j < points.length; j++) {
          let linePoints = points[j];
          for (var i = 1; i < linePoints.length; i++) {
              var edgeDistance = linePoints[i - 1].distanceTo(linePoints[i]);
              if (currentDistance + edgeDistance > distance) {
                  result.index = i;
                  result.section = j;
                  result.edgeDistance = distance - currentDistance;
                  result.point =
                      MapHelper.edgePositionByDistance(result.edgeDistance, linePoints[i - 1], linePoints[i]);
                  found = true;
                  break;
              }
              currentDistance += edgeDistance;
          }
          if (found)
              break;
      }

      //Ставим на конец, когда не вошли в длину дороги.
      if (result.index == null && points.length && points[points.length - 1].length > 1) {
          result.index = points[points.length - 1].length - 1;
          result.section = points.length - 1;
          result.point = points[points.length - 1][result.index];
          result.edgeDistance = points[points.length - 1][result.index - 1].distanceTo(result.point);
      }

    return result;
  };

  /**
   * Вернет новую точку на ребре между двумя точками, отстоящую от начала ребра на растояние distance
   * 
   * @public
   * @param {double} distance Растояние от начала ребра в киллометрах
   * @param {LatLng} startPoint Точка начала ребра
   * @param {LatLng} endPoint Точка конца ребра
   * @returns {LatLng}
   */
  MapHelper.edgePositionByDistance = function (distance, startPoint, endPoint) {
    var edgeDistance = startPoint.distanceTo(endPoint);
    var lat = (endPoint.lat - startPoint.lat) / edgeDistance * distance + startPoint.lat;
    var lng = (endPoint.lng - startPoint.lng) / edgeDistance * distance + startPoint.lng;
    return L.latLng(lat, lng);
  };

  /**
   * Возвращение фрагмента линии между заданными начальным и конечным километрами в виде строки с координатами
   * 
   * @public
   * @param {} startKm 
   * @param {} endKm 
   * @param {} linePoints 
   * @returns {} 
   */
  MapHelper.getLongObjectCoordinatesCsv = function (startKm, endKm, linePoints) {

    if (linePoints.length < 2) return null;

    var result = { startKm: 0, stopKm: 0 };
    if (startKm < endKm) {
      result.startKm = startKm;
      result.stopKm = endKm;
    } else {
      result.startKm = endKm;
      result.endKm = startKm;
    }

    var start = MapHelper.findPositionByDistance(startKm * 1000, linePoints);
    var end = MapHelper.findPositionByDistance(endKm * 1000, linePoints);

    var points = [];

    points.push(start.point);
    for (var i = start.index; i < end.index; i++) {
      points.push(linePoints[i]);
    }
    points.push(end.point);

    var coordinatesSvg = points.map(function (p) {
      return p.lat + ',' + p.lng;
    }).join('\n');

    return coordinatesSvg;
  }

    /**
     * Вычисление длины составной линии
     * @param {any} linePoints Массив координат
     */
    MapHelper.getLength = function(points) {
        if (!Array.isArray(points[0])) {
            points = [points];
        }
        var length = 0;
        var found = false;
        for (var j = 0; j < points.length; j++) {
            let linePoints = points[j];
            for (var i = 1; i < linePoints.length; i++) {
                length += linePoints[i - 1].distanceTo(linePoints[i]);
            }
        }
        return length;
    }

  return MapHelper;
})();
